<template>
  <div class="highlight-page">
    <app-page-header title="Produtos em Destaque">
      <button @click="create()" v-app-button.icon-left>
        <b-icon size="is-small" icon="plus"></b-icon>NOVO
      </button>
    </app-page-header>

    <store-highlight-table></store-highlight-table>
  </div>
</template>

<script>
import StoreHighlightTable from '@/components/Tables/StoreHighlightTable.vue';

export default {
  name: 'store-highlights-page',
  components: {
    StoreHighlightTable,
  },
  methods: {
    create() {
      this.$router.push('/store-highlights/create');
    },
  },
};
</script>
